import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getAdminFeeConfig, updateAdminFeeConfig } from '@/services/user-settings.service';
import type { AdminFeeConfig } from '@/types/api.types';

const adminFeeConfigKey = ['user-settings', 'admin-fee-config'];

export const useAdminFeeConfig = () => {
  return useQuery({
    queryKey: adminFeeConfigKey,
    queryFn: getAdminFeeConfig,
    staleTime: 1000 * 60 * 5,
  });
};

export const useUpdateAdminFeeConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: AdminFeeConfig) => updateAdminFeeConfig(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminFeeConfigKey });
    },
  });
};
